'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dStore$002dCart from "./mealorama.-Store-Cart.js";
var $p;
/** @constructor */
function $c_Lmealorama_StoreCart$() {
}
export { $c_Lmealorama_StoreCart$ as $c_Lmealorama_StoreCart$ };
$p = $c_Lmealorama_StoreCart$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_StoreCart$;
/** @constructor */
function $h_Lmealorama_StoreCart$() {
}
export { $h_Lmealorama_StoreCart$ as $h_Lmealorama_StoreCart$ };
$h_Lmealorama_StoreCart$.prototype = $p;
$p.m = (function() {
  return "StoreCart";
});
$p.aSy = (function(x$0) {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.g(0));
  return new $j_mealorama$002e$002dStore$002dCart.$c_Lmealorama_StoreCart($x_1.l, $x_1.h, x$0.g(1), x$0.g(2), x$0.g(3), x$0.g(4), x$0.g(5));
});
var $d_Lmealorama_StoreCart$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_StoreCart$, "mealorama.StoreCart$", ({
  H2: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_StoreCart$ as $d_Lmealorama_StoreCart$ };
var $n_Lmealorama_StoreCart$;
function $m_Lmealorama_StoreCart$() {
  if ((!$n_Lmealorama_StoreCart$)) {
    $n_Lmealorama_StoreCart$ = new $c_Lmealorama_StoreCart$();
  }
  return $n_Lmealorama_StoreCart$;
}
export { $m_Lmealorama_StoreCart$ as $m_Lmealorama_StoreCart$ };
//# sourceMappingURL=mealorama.-Store-Cart$.js.map
